module.exports = __webpack_public_path__ + "static/media/old-phone.30ae04a2.png";